<template>
  <div class="forms-list" :data-show="show">
    <template v-if="['ready', 'liveStarting', 'live', 'liveStopping'].includes(broadcast.status.life_cycle_status)">
      <Button class="no-border-radius white f-w bold" icon="plusCircle" @click="newForm">Add new form</Button>
    </template>
    <div class="forms nice-scrollbar">
      <template v-if="fetching">
        <div class="loading-spinner m-a-a"></div>
      </template>
      <template v-else>
        <template v-if="forms.length > 0">
          <div class="app-item" v-for="form in forms" :key="form.id" @click="openForm(form.id)">
            <div class="info">
              <h2>{{ form.title }}</h2>
              <p class="">{{ form.state | formState }} {{ ['published', 'completed'].includes(form.state) ? `- ${form.submissions.length} submission${form.submissions.length === 1 ? '' : 's'}` : '' }}</p>
            </div>
            <div class="controls">
              <i :class="`icon-megaphone-tilted ${form.state === 'published' && !['complete', 'abandoned'].includes(broadcast.status.life_cycle_status) ? '' : 'gray'}`" @click.prevent.stop="promoteForm(form)" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="d-f ai-c jc-c f-1 ta-c p-a-4 page-placeholder-text">
            <p>No forms created yet.</p>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
    /**
     * Get current list of forms
     * @returns {Array}
     */
    forms() {
      const stateOrder = {
        created: 0,
        published: 1,
        completed: 2,
      };

      const forms = this.$store.getters['Forms/forms'];

      return forms.sort((a, b) => stateOrder[a.state] - stateOrder[b.state]);
    },
  },
  methods: {
    newForm() {
      this.$store.commit('Forms/toggleCreate', true);
    },
    openForm(id) {
      this.$store.dispatch('Forms/getForm', { id });
    },
    promoteForm(form) {
      if (form.state !== 'published' || ['complete', 'abandoned'].includes(this.broadcast.status.life_cycle_status)) {
        return;
      }

      this.$store.dispatch('Forms/promoteForm', form.id);
    },
  },
  async mounted() {
    await this.$store.dispatch('Forms/getForms', {
      id: this.broadcast.id,
      clear: true,
    });

    this.fetching = false;
  },
  data() {
    return {
      fetching: true,
    };
  },
  filters: {
    /**
     * Truncate long strings
     * @param {String} string
     * @param {Number} length Defaults to 100
     * @returns {String}
     */
    formState(state) {
      switch (state) {
        case 'created':
          return 'Unpublished';
        case 'published':
          return 'Published';
        case 'completed':
          return 'Closed';
        default:
          return '';
      }
    },
  },
};
</script>
<style lang="scss">
/** {
  min-width: 0;
}*/
</style>

<style lang="scss" scoped>
.elip {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.forms-list {
  background: #F3F5F9;
  box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, .10);
  flex: 1;
  display: none;
  flex-direction: column;
  overflow: hidden;

  &[data-show="true"] {
    display: flex;
  }

  .forms {
    overflow: auto;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-top: 1px solid #C1C5D7;
    flex: 1;
  }
}
</style>
